<template>
  <div class="isTxt" v-if="isTxt">
    {{ !isNullOrUndefOrEmpty(innerValue) ? innerValue : '-' }}
  </div>
  <RxkSelect v-else :list="list" v-model="innerValue" :disabled="true" />
</template>
<script lang="ts" setup>
import { computed, onMounted, ref, unref } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkSelect } from '@/components/common/RxkSelect'
import { getPageComponentDataEchoAcquire } from '@/apis/customerManage'
import { isNullOrUndefOrEmpty } from '@/utils/is'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList', 'updadeViewData'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})

const list = ref([])
onMounted(() => {
  props?.data?.renderConfig?.referralPersonEmitter?.on?.(
    'referralPersonChange',
    referralPersonChange
  )
})

const flag = ref(true)
function referralPersonChange(val: number) {
  console.log(val, 'pppppppp')
  if (val && flag.value) {
    getPageComponentDataEchoAcquire({
      columnId: props.data.id,
      echoData: val
    }).then(res => {
      console.log(res, 78910)
      if (res.length) {
        list.value = res
        innerValue.value = res[0].value
        flag.value = false
        emit('refreshDataList', unref(list))
        emit('updadeViewData', unref(innerValue))
      }
    })
  }
}
</script>
